<template lang="pug">
v-container(fluid, tag="div")
  v-row
    v-col(cols="12", md="6")
      v-card
        v-card-title Online Demo
        v-card-text
          v-form(ref="form", v-model="valid", lazy-validation)
            v-file-input(
              show-size,
              :rules="rules",
              accept="image/png, image/jpeg, image/bmp",
              placeholder="Pick an front IC image",
              prepend-icon="mdi-camera",
              label="Front IC Image",
              @change="setImage($event, 1)"
            )
            v-file-input(
              show-size,
              :rules="rules",
              accept="video/mp4",
              placeholder="Pick a selfie video",
              prepend-icon="mdi-video",
              label="Selfie Video",
              @change="setImage($event, 2)"
            )
        v-card-actions
          v-spacer
          v-btn(color="blue darken-1", text, @click="reset") Reset
          v-btn(color="blue darken-1", text, @click="submit") Submit
      v-card(v-if="loading")
        i.fas.fa-spin.fa-spinner.fa-5x.mx-auto(v-if="loading")
      v-card(v-else-if="result")
        v-card-title Result
        v-card-text
          pre.mb-4 Similarity Score: {{ result.Sim }}
          img(width="300" :src="`data:image/jpeg;base64,${result.BestFrameBase64}`")
    v-col(cols="12", md="6")
      v-card
        v-card-title API Integration
        v-card-text
          h5.text-info Request Body
          pre.mb-4 {{ JSON.stringify(exampleRequest, null, 2) }}
          h5.text-danger Response Body
          pre.mb-4 {{ JSON.stringify(exampleResponse, null, 2) }}
</template>

<script>
export default {
  data() {
    return {
      rules: [
        (value) =>
          !value ||
          value.size < 5000000 ||
          "Avatar size should be less than 5 MB!",
      ],
      valid: false,
      frontImage: "",
      selfieVideo: "",
      exampleRequest:
        "{username: 'YOUR_USERNAME', auth_key: 'YOUR AUTH_KEY', front_image: 'Base64 string of front IC image', selfie_video: 'Base64 string of selfie video' }",
      exampleResponse:
        "{'result': { 'SIM': CONFIDENCE_SCORE, 'BestFrameBase64': 'Base64 string of best frame detected'} }",
      result: null,
      loading: false,
    };
  },
  methods: {
    setImage(e, i) {
      var reader = new FileReader();
      reader.onload = (event) => {
        if (i == 1) this.frontImage = event.target.result;
        if (i == 2) this.selfieVideo = event.target.result;
      };
      reader.readAsDataURL(e);
    },
    submit() {
      if (!this.$refs.form.validate()) return;

      const url = "https://saas-api.xendity.com/v1/webservice/liveness";

      var now = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      var string =
        this.$store.getters.authKey +
        this.$store.getters.apiKey +
        this.$store.getters.userName +
        this.$store.getters.apiKey +
        now;

      var string1 = this.CryptoJS.enc.Utf8.parse(this.CryptoJS.MD5(string));
      var signature = this.CryptoJS.enc.Base64.stringify(string1);

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        front_image: this.frontImage,
        selfie_video: this.selfieVideo.split(",")[1],
        signature: signature,
        request_time: now,
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal("Liveness error", response.body.data.message, "error");
              else this.result = response.body.data.result;
            }
          } catch (error) {
            this.$swal("Liveness error", response.body.data.message, "error");
          }
        })
        .catch((response) => {
          this.$swal("Liveness error", response.body.data.message, "error");
        });
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>